export default __webpack_public_path__ + "static/about-us-1-db9848bc0c6dbd9ca9f8f18354d26482.png";